import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {
  public secretKey: string; // Replace with your secret key
  public postKey: string;
  public base64;
  public randomKey: string;

  constructor() { }


  public encryptData(data, key, iv) {
    // console.log("data", data);
    const encryptedData = CryptoJS.AES.encrypt(data, key, { iv: iv || null }).toString();
    return encryptedData;
  };
  // Function to decrypt data without IV
  public decryptData(encryptedData, key, iv?) {
    const decryptedData = CryptoJS.AES.decrypt(encryptedData, key, { iv: iv || null }).toString(CryptoJS.enc.Utf8);
    return decryptedData;
  }


  public getKey(data) {
    let starting: string = '';
    let ending: string = '';
    if (data?.length >= 50) {
      starting = data.slice(0, 50);
      ending = data.slice(-50);
    }
    return starting + ending;
  }


  public getData(data: string) {
    let leftData: string;
    leftData = data.slice(50, -50);
    return leftData;
  }

  public genrateKey() {
    const token = localStorage.getItem('userToken');
    this.base64 = this.stringToBase64(token);
    const key = this.base64.slice(0, 50);
    return key;
  }

  stringToBase64(input) {
    // Define the Base64 encoding table
    const base64Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Convert the input string to UTF-8 bytes
    const bytes = [];
    for (let i = 0; i < input.length; i++) {
      const charCode = input.charCodeAt(i);

      // Handle multi-byte UTF-8 characters
      if (charCode < 128) {
        bytes.push(charCode);
      } else if (charCode < 2048) {
        bytes.push(192 | (charCode >> 6)); // first byte
        bytes.push(128 | (charCode & 63)); // second byte
      } else {
        bytes.push(224 | (charCode >> 12)); // first byte
        bytes.push(128 | ((charCode >> 6) & 63)); // second byte
        bytes.push(128 | (charCode & 63)); // third byte
      }
    }

    // Encode the bytes into Base64
    let base64 = '';
    for (let i = 0; i < bytes.length; i += 3) {
      // Get the three bytes to encode
      const b1 = bytes[i];
      const b2 = (i + 1 < bytes.length) ? bytes[i + 1] : 0;
      const b3 = (i + 2 < bytes.length) ? bytes[i + 2] : 0;

      // Create four 6-bit values from the three bytes
      const enc1 = b1 >> 2;
      const enc2 = ((b1 & 3) << 4) | (b2 >> 4);
      const enc3 = ((b2 & 15) << 2) | (b3 >> 6);
      const enc4 = b3 & 63;

      // Add the Base64 characters to the result
      base64 += base64Chars[enc1];
      base64 += base64Chars[enc2];
      base64 += (i + 1 < bytes.length) ? base64Chars[enc3] : '=';
      base64 += (i + 2 < bytes.length) ? base64Chars[enc4] : '=';
    }

    return base64;
  }



  public genrateRandomKeys(length = 100) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let key = '';
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charactersLength);
      key += characters[randomIndex];
    }

    return key;
  }


}
